<template>
  <div>
    <div class="p-t-none">
      <div class="tituloBox">
        <div class="bg-red barraTitulo"></div>
        <h1 class="text-default font-size-14">
          <strong>Dirigentes</strong>
        </h1>
      </div>
    </div>
    <div class="clear"></div>
    <v-data-table
      :headers="dadosBasicosSocioDirigente.concat(localcabecalhoDirigentes)"
      :items="dirigentesLista"
      :loading="loading"
      :hide-actions="true"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.nome }}</td>
        <td class="text-xs-left">
          <input
            v-if="props.item.flagEstrangeiro == 0"
            v-mask="(props.item.tipoHabilitador =='J') ? maskCnpj : maskCpf"
            readonly
            :value="props.item.cpfCnpj"
          >
          <input
            v-if="props.item.flagEstrangeiro == 1"
            readonly
            :value="props.item.cpfCnpj"
          >
        </td>
        <td class="text-xs-center">{{ props.item.flagEstrangeiro == "0" ? "Sim" : "Não" }}</td>
        <td class="text-xs-center">{{ props.item.cargo }}</td>
        <td v-if="$verificaPerfilCadastrador() || $verificaPerfilHabilitador()" class="text-xs-center naoImprimir">
       
          <a v-if="props.item.numDocumentoSEI" v-bind:href="props.item.arquivoUpload" target="_blank">
            <v-icon color="blue">attach_file</v-icon>
          </a>
          <v-icon v-else color="grey">attach_file</v-icon> 
        </td> 
      </template>
    </v-data-table>
  </div>
</template>



<script>
import util from "../../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
export default {
  name: "extrato-dirigentes-table",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object
  },
  created() /*Metodo de start do componente*/{},
  computed: {//Campos computados
    dirigentesLista(){
      //retorna a lista de dirigentes
      if(!this.model.fornecedoresHabilitacaoJuridica) return [];
      let lista = this.model.fornecedoresHabilitacaoJuridica.filter(
        item => item.tipoCadastro === "D"
      );
      if (lista.length) return lista;
      else return [];
    }
  },
  mounted() {
    this.localcabecalhoDirigentes = this.cabecalhoDirigentes; // Inicializa com os headers do mixin
    if (this.$verificaPerfilCadastrador() || this.$verificaPerfilHabilitador()) {
      this.localcabecalhoDirigentes.push({
        text: this.$t("label.anexo"),
        align: "center",
        sortable: false,
        class: "naoImprimir",
      });
    }
  },
  data() {//Declaracao de variaveis
    return {
      localcabecalhoDirigentes: [],
      crud: false,
      totalDesserts: 0,
      loading: false,
    };
  },
};
</script>